import { Component, OnDestroy, OnInit, input, inject } from '@angular/core';
import { FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ApContentService, ApKeyOverridePipe, ApContentPipe } from '@ap/content';
import { ErrorMessages } from '@ap/form/errors';
import { ApRadioGroupComponent, ApRadioButtonComponent } from '@ap/radio';
import { ApCheckboxComponent } from '@ap/checkbox';
import { ApFormControlPipe } from '@ap/cdk';
import { ApAmountInputComponent } from '@ap/input/amount';

import content from '../income.content.json';
import { MonthlyIncomeForm } from '../income.model';

@Component({
    selector: 'ap-employment-income',
    templateUrl: './employment-income.component.html',
    imports: [
        ApAmountInputComponent,
        FormsModule,
        ReactiveFormsModule,
        ApRadioGroupComponent,
        ApRadioButtonComponent,
        ApCheckboxComponent,
        ApFormControlPipe,
        ApContentPipe,
        ApKeyOverridePipe
    ]
})
export class ApEmploymentIncomeComponent implements OnInit, OnDestroy {
    contentService = inject(ApContentService);

    public readonly form = input.required<FormGroup<MonthlyIncomeForm>>();
    public readonly numberOfDecimals = input(2);
    public readonly contentKeyMap = input({});

    private bonusChangeSubscription: Subscription;

    public monthlyIncomeErrorMessages: ErrorMessages;
    public bonusPaymentErrorMessages: ErrorMessages;
    public incomeServiceKey: string;

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        this.bonusChangeSubscription = this.form().controls.hasBonusPayment.valueChanges.subscribe((value) =>
            this.setBonusPaymentRequired(value)
        );
        this.setErrorMessages();
    }

    public ngOnDestroy(): void {
        this.bonusChangeSubscription.unsubscribe();
    }

    private setErrorMessages(): void {
        this.incomeServiceKey = 'income.input.monthlyIncome';
        this.bonusPaymentErrorMessages = {
            required: this.contentService.get('income.input.bonusPayment.error.required')
        };
        this.monthlyIncomeErrorMessages = {
            min: this.getKey('income.input.monthlyIncome.error.min'),
            max: this.getKey('income.input.monthlyIncome.error.max'),
            required: this.getKey('income.input.monthlyIncome.error.required')
        };
    }

    private getKey(initialKey: string): string {
        return new ApKeyOverridePipe().transform(initialKey, this.contentKeyMap());
    }

    private setBonusPaymentRequired(required: boolean): void {
        if (required) {
            this.form().controls.bonusPayment.addValidators(Validators.required);
        } else {
            this.form().controls.bonusPayment.removeValidators(Validators.required);
        }
        this.form().controls.bonusPayment.markAsPristine();
        this.form().controls.bonusPayment.markAsUntouched();
        this.form().controls.bonusPayment.updateValueAndValidity();
    }
}
